"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _Select = require("../Select");
var _excluded = ["defaultValue", "onChange", "value"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var WithContainer = function WithContainer(props) {
  var defaultValue = props.defaultValue,
    onChange = props.onChange,
    value = props.value,
    originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useControlledState = (0, _reactUseControlledState["default"])(defaultValue, value, onChange),
    _useControlledState2 = (0, _slicedToArray2["default"])(_useControlledState, 2),
    stateValue = _useControlledState2[0],
    setStateValue = _useControlledState2[1];
  var handleChange = (0, _react.useCallback)(function (e) {
    setStateValue(e.currentTarget.value);
  }, [setStateValue]);
  var addProps = {
    onChange: handleChange,
    value: stateValue
  };
  return /*#__PURE__*/_react["default"].createElement(_Select.Select, (0, _extends2["default"])({}, originalProps, addProps));
};
exports.WithContainer = WithContainer;